import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Profile(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21"
  }, props), React.createElement("path", {
    d: "M5.75 6.063a4.25 4.25 0 118.5 0v2.5a4.25 4.25 0 11-8.5 0v-2.5zM10 .313a5.75 5.75 0 00-5.75 5.75v2.5a5.73 5.73 0 001.533 3.909l-4.453 2.26c-.764.39-1.305 1.134-1.305 2.008v1.74c0 .69.56 1.25 1.25 1.25h17.437c.69 0 1.25-.56 1.25-1.25v-1.74c0-.876-.54-1.62-1.305-2.008l-4.444-2.257a5.73 5.73 0 001.537-3.912v-2.5A5.75 5.75 0 0010 .313zm2.935 13.195a5.726 5.726 0 01-2.935.805 5.723 5.723 0 01-2.94-.808L2.01 16.07c-.346.175-.485.448-.485.67v1.49h16.937v-1.49c0-.223-.14-.495-.485-.67l-5.042-2.562z"
  }));
}

export { Profile };
//# sourceMappingURL=Profile.js.map